import { WorkspaceQueueColumnDto } from '@mark43/cad-api';
import { observable, makeObservable, action } from 'mobx';
import columnDefinitionEnum from '../queues/column-definition.enum';
import { Optional } from '../queues/types';
import { v4 as uuidv4 } from 'uuid';
import { WorkspaceQueueDelegate } from './workspace-queue';

export class WorkspaceQueueColumn
    implements Optional<WorkspaceQueueColumnDto, 'columnPosition' | 'id'> {
    id: WorkspaceQueueColumnDto['id'] | undefined;
    temporaryId?: WorkspaceQueueColumnDto['temporaryId'];
    columnPosition: WorkspaceQueueColumnDto['columnPosition'] | undefined;
    columnDefinition: WorkspaceQueueColumnDto['columnDefinition'];
    queueId: WorkspaceQueueColumnDto['queueId'];
    @observable
    width: WorkspaceQueueColumnDto['width'];
    delegate: WorkspaceQueueDelegate;
    constructor(
        configuration: Optional<WorkspaceQueueColumnDto, 'columnPosition' | 'id'>,
        delegate: WorkspaceQueueDelegate
    ) {
        this.id = configuration.id;
        if (!this.id) {
            this.temporaryId = uuidv4();
        }
        this.columnPosition = configuration.columnPosition;
        this.columnDefinition = configuration.columnDefinition;
        this.queueId = configuration.queueId;
        this.width = configuration.width;
        this.delegate = delegate;
        makeObservable(this);
    }

    public getDto(): Omit<WorkspaceQueueColumnDto, 'columnPosition'> {
        return {
            id: this.id!,
            temporaryId: this.temporaryId,
            columnDefinition: this.columnDefinition,
            queueId: this.queueId,
            width: this.width,
        };
    }

    get isSearchable(): boolean {
        return columnDefinitionEnum[this.columnDefinition].searchable;
    }

    get isGroupable(): boolean {
        return columnDefinitionEnum[this.columnDefinition].groupable;
    }

    get displayName(): string {
        return columnDefinitionEnum[this.columnDefinition].displayName;
    }

    get abbreviation(): string {
        return columnDefinitionEnum[this.columnDefinition].columnAbbreviation;
    }

    @action
    public setWidth(width: number): void {
        this.width = width;
        this.delegate.enqueueSaveWorkspaceWindow();
    }
}
